/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { List } from '@mairistem/composants';

import type { Adresse as AdresseType } from '@/types';

interface AdresseProps {
  /** Adresse */
  adresse?: Partial<AdresseType>;
}

const Adresse = (props: AdresseProps) => {
  const { adresse } = props;

  const {
    numeroVoirie,
    indiceRepetition,
    complementNumeroVoirie,
    typeVoie,
    libelleVoie,
    libelleCodePostal,
    libelleCommune,
    libellePays,
  } = adresse || {};

  return (
    <List>
      <List.Description>
        {_.isNumber(numeroVoirie) && numeroVoirie !== 0 && `${numeroVoirie} `}
        {!_.isEmpty(indiceRepetition) && `${indiceRepetition} `}
        {!_.isEmpty(complementNumeroVoirie) && `${complementNumeroVoirie} `}
        {!_.isEmpty(typeVoie) && `${typeVoie} `}
        {libelleVoie}
      </List.Description>
      <List.Description>
        {!_.isEmpty(libelleCodePostal) && `${libelleCodePostal} `}
        {!_.isEmpty(libelleCommune) && `${libelleCommune} `}
      </List.Description>
      <List.Description>{libellePays}</List.Description>
    </List>
  );
};

export default Adresse;
